'use client';

import styled from 'styled-components';

import { theme } from '@zoomit/zoomit-ds';

import type { DisplaySource } from '../../types/modules';

type Props = {
  source: DisplaySource;
  code: string;
  onDisplayClick(): void;
  hasBorderRadius: boolean;
};

const IframeSource = (props: Props) => {
  const { source, code, onDisplayClick, hasBorderRadius } = props;
  if (source.sourceType !== 'Iframe') return null;
  return (
    <Root
      hasBorderRadius={hasBorderRadius}
      data-code={code}
      onClick={onDisplayClick}
      onKeyDown={onDisplayClick}
      role="button"
      tabIndex={0}
      dangerouslySetInnerHTML={{
        __html: source.content,
      }}
    />
  );
};

export default IframeSource;

const Root = styled.div<{ hasBorderRadius: boolean }>`
  border-radius: ${({ hasBorderRadius }) => (hasBorderRadius ? `var(${theme.radius.sm})` : 'unset')};

  [data-theme='dark'] & .dark-container {
    filter: invert(100%);
  }

  iframe {
    border-radius: inherit;
  }
`;
